/**
 * "2 sezon · 16 bölüm".
 *
 * Both series screens want this line and neither should own the wording — the phrase is
 * two words of Turkish and the rule for dropping half of it is a judgement, so having it
 * written twice is how the two screens end up disagreeing about a show.
 *
 * ## No backend change
 *
 * §24 item 6 asks for `episodeCount` / `seasonCount` on the series. The **detail** header
 * needs neither: `SeriesDetailDto.seasons[].episodeCount` is already there and summing it
 * is exact. What genuinely needs the backend is the count on a *card*, and that is blocked
 * by something the plan does not mention — episodes are fetched on first open, so for a
 * library of 292 series almost none have children and almost every card would have nothing
 * to show.
 */
import type { SeasonDto } from '@filmodasi/shared';

/**
 * The summary line, or null when there is nothing to say.
 *
 * Null for a series whose episodes have not been fetched yet — both screens already render
 * "bölümleri henüz alınmadı" in that case, and a "0 bölüm" beside it would read as a fact
 * about the show rather than about what has been downloaded.
 *
 * The season half is dropped for a single-season show: "1 sezon" is not information, it is
 * the absence of the thing the word is there to disambiguate.
 */
export function seriesCounts(seasons: SeasonDto[]): string | null {
  if (seasons.length === 0) return null;

  const episodes = seasons.reduce((total, s) => total + s.episodeCount, 0);
  if (episodes === 0) return null;

  const parts: string[] = [];
  if (seasons.length > 1) parts.push(`${seasons.length} sezon`);
  parts.push(`${episodes} bölüm`);
  return parts.join(' · ');
}
